// extracted by mini-css-extract-plugin
export var divider = "_xr-0";